import { LitElement, html, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
export interface VideoOpenDetail {
  title: string;
  videoId: string;
  downloadUrl?: string;
  posterUrl?: string;
  embedHtml?: string;
}

@customElement('imos-video-modal')
export class ImosVideoModal extends LitElement {
  @state() private show = false;
  @state() private title = '';
  @state() private downloadUrl = '';
  @state() private videoId = '';
  @state() private posterUrl = '';
  @state() private embedHtml = '';

  private boundOpen = this.open.bind(this);

  protected createRenderRoot(): this {
    return this;
  }

  connectedCallback(): void {
    super.connectedCallback();
    window.addEventListener('imos-video-open', this.boundOpen as EventListener);
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    window.removeEventListener('imos-video-open', this.boundOpen as EventListener);
  }

  private get dialogEl(): HTMLDialogElement | null {
    return this.querySelector('dialog');
  }

  private open(e: CustomEvent<VideoOpenDetail>): void {
    this.title = e.detail.title;
    this.videoId = e.detail.videoId;
    this.downloadUrl = e.detail.downloadUrl ?? '';
    this.posterUrl = e.detail.posterUrl ?? '';
    this.embedHtml = e.detail.embedHtml ?? '';
    this.show = true;

    this.updateComplete.then(() => {
      const dialog = this.dialogEl;
      if (dialog && !dialog.open) {
        dialog.showModal();
      }

      // Wire up native close event (ESC key handled automatically by <dialog>)
      dialog?.addEventListener('close', () => this.handleDialogClose(), { once: true });

      const player = this.querySelector('imos-video-player') as any;
      player?.loadVideo(this.videoId, this.embedHtml);
    });
  }

  private handleDialogClose(): void {
    this.show = false;
    window.dispatchEvent(
      new CustomEvent('stopvideo', { detail: this.videoId }),
    );
  }

  private close(): void {
    this.dialogEl?.close();
  }

  protected render() {
    if (!this.show) return nothing;

    return html`
      <dialog
        class="backdrop:bg-black/70 p-0 bg-transparent max-w-none w-full h-full m-0 max-h-none"
      >
        <div
          class="w-full h-full py-xs portrait:px-xs lg:px-m xl:px-xl 3xl:px-3xl flex flex-col justify-center"
          @click=${(e: Event) => { if (e.target === e.currentTarget) this.close(); }}
        >
          <div class="bg-white relative mx-auto w-full max-w-7xl">
            <button
              class="absolute right-0 bottom-full"
              @click=${() => this.close()}
            >
              <i class="icon--imos-webicon_x text-white"></i>
            </button>
            <imos-video-player
              video-id=${this.videoId}
              poster-image=${this.posterUrl}
            ></imos-video-player>
            <div class="flex justify-between items-baseline p-2xs text-xs">
              <div>${this.title}</div>
              <div>
                ${this.downloadUrl
                  ? html`<a
                      href=${this.downloadUrl}
                      target="_blank"
                      class="btn btn--xs"
                      >Download</a
                    >`
                  : nothing}
              </div>
            </div>
          </div>
        </div>
      </dialog>
    `;
  }
}
